/* @flow */

import * as React from 'react';
import PxcContext from '../contexts/PxcContext';

function withPxc(Component: React.ComponentType<*>) {
  return (props: Object) => (
    <PxcContext.Consumer>
      {context => (
        <Component
          {...props}
          pxc={context}
        />
      )}
    </PxcContext.Consumer>
  );
}

export default withPxc;
